import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { surveysEntryPoint } from '@atlassian/jira-spa-apps-project-settings-servicedesk-surveys/entrypoint.tsx';

export const surveysPageEntryPoint = createPageEntryPoint({
	main: surveysEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
